import {
  WbAlert,
  WbButton,
  WbCard,
  WbCardContent,
  WbTabPanel,
} from '@agilelab/plugin-wb-platform';
import { FC, useMemo } from 'react';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { TeamRoleAsString } from '../../../types';
import { useTeamRolesPanelContext } from '../../../context';
import { TeamRoleAssignmentsTable } from './TeamRoleAssignmentsTable';
import { TeamRoleEnum } from '@agilelab/plugin-wb-team-roles-common';
import { CreateTeamRoleAssignmentDrawer } from '../CreateTeamRoleAssignmentDrawer';

export const TeamRoleAssignmentsCard: FC = () => {
  const {
    selectedTeamRole,
    hasMultiplePrincipalOwners,
    hasTroubleshootAccess,
    isOwner,
    isLimitedOwner,
    assignments,
    enabledTeamRoles,
    openCreateTeamRoleAssignmentDrawer,
    setOpenCreateTeamRoleAssignmentDrawer,
  } = useTeamRolesPanelContext();

  const canCreateAssignment = useMemo(
    () =>
      assignments &&
      assignments.length > 0 &&
      (isOwner ||
        hasTroubleshootAccess ||
        (selectedTeamRole !== TeamRoleEnum.OWNER && isLimitedOwner)),
    [
      assignments,
      isOwner,
      isLimitedOwner,
      hasTroubleshootAccess,
      selectedTeamRole,
    ],
  );

  return (
    <WbCard
      title={`${TeamRoleAsString[selectedTeamRole]} Assignments`}
      cardStyle={{ height: '100%', overflow: 'hidden' }}
      actions={
        canCreateAssignment ? (
          <WbButton
            label="Add Assignment"
            startIcon={<AddCircleIcon />}
            color="primary"
            onClick={() => {
              setOpenCreateTeamRoleAssignmentDrawer(true);
            }}
          />
        ) : undefined
      }
    >
      {enabledTeamRoles.map((_role, index) => (
        <WbTabPanel index={index}>
          <WbCardContent style={{ height: '100%' }}>
            {selectedTeamRole === TeamRoleEnum.OWNER && (
              <>
                {hasMultiplePrincipalOwners && (
                  <WbAlert
                    style={{ marginBottom: 16 }}
                    variant="collapsible"
                    message={{
                      title: `Multiple Full ${
                        TeamRoleAsString[TeamRoleEnum.OWNER]
                      }s detected`,
                      type: 'warning',
                      content:
                        hasTroubleshootAccess || isOwner
                          ? 'Having multiple Full Owners creates ambiguity. Witboost cannot determine which one to write into the project descriptor, so the descriptor may be out of sync with what is configured here. To resolve this, keep exactly one Full Owner.'
                          : 'Multiple Full Owners create ambiguity that may cause the project descriptor to be out of sync with Team Roles settings. Please contact a Full Owner or the Platform Team to resolve this.',
                    }}
                  />
                )}
              </>
            )}
            <TeamRoleAssignmentsTable />
          </WbCardContent>
        </WbTabPanel>
      ))}
      <CreateTeamRoleAssignmentDrawer
        open={openCreateTeamRoleAssignmentDrawer}
        setOpen={setOpenCreateTeamRoleAssignmentDrawer}
      />
    </WbCard>
  );
};
